export const elem = document.querySelector('.gallery__wrap');
export const gallery = document.querySelector('.gallery__list');
export const STORAGE_KEY = 'favorite-cocktails';
export const STORAGE_KEY_INGREDIENT = 'favorite-ingredients';
export const modalIngredientEl = document.querySelector('#modal-ingredient');
export const overlayIngredient = document.querySelector('#overlay-ingredient');
export const heroSearchCoctailsEl = document.querySelector('.hero_search_coctails');
export const heroListEl = document.querySelector('.hero_list');